"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setStyle = exports["default"] = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _toolTip = _interopRequireDefault(require("../toolTip"));
var _buttonModule = _interopRequireDefault(require("./button.module.scss"));
var _utilities = require("../utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var setStyle = exports.setStyle = function setStyle(props) {
  return "".concat(_buttonModule["default"].button, " ").concat(_buttonModule["default"][props.colour], " ").concat(_buttonModule["default"][props.style], " ").concat(props.disabled && _buttonModule["default"].disabled, " ").concat(_buttonModule["default"][props.size]);
};
var Button = exports.Button = function Button(props) {
  var buttonRef = /*#__PURE__*/_react["default"].createRef();
  var buttonStyle = setStyle(props);
  var style = {};

  /* istanbul ignore else */
  if (props.width && props.width !== "auto") {
    style.width = "".concat(props.width, "px");
  }
  var DisabledToolTip = function DisabledToolTip(props) {
    if (props.disabled && props.disabledMessage) {
      return /*#__PURE__*/_react["default"].createElement(_toolTip["default"], {
        type: "Notice",
        show: "click",
        position: "Top",
        target: buttonRef
      }, [/*#__PURE__*/_react["default"].createElement("div", {
        key: 1,
        className: _buttonModule["default"].toolTip
      }, props.disabledMessage)]);
    } else {
      return null;
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", _extends({
    "data-testid": "button"
  }, _utilities.utilities.getDataAttributes(props), {
    className: buttonStyle,
    onClick: function onClick(event) {
      return !props.disabled && props.onClick(event);
    },
    style: style,
    ref: buttonRef,
    "data-disabled": props.disabled
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _buttonModule["default"].inner
  }, props.children)), /*#__PURE__*/_react["default"].createElement(DisabledToolTip, props));
};
Button.propTypes = {
  colour: _propTypes["default"].oneOf(["Grey", "LightGrey", "Pink", "Blue", "LightBlue", "Red", "Green"]),
  style: _propTypes["default"].oneOf(["Solid", "Outline"]),
  size: _propTypes["default"].oneOf(["Default", "Small"]),
  text: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  disabledMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  onClick: _propTypes["default"].func
};
Button.defaultProps = {
  colour: "Grey",
  style: "Solid",
  size: "Default",
  text: "Button",
  width: "auto",
  disabled: false,
  disabledMessage: null,
  onClick: null
};
var _default = exports["default"] = Button;